<template>
  <div v-if="productOptsSummaryParsed" class="product-opts-summary">
    <div v-if="full" class="full">
      <div v-for="(opt, key) in productOptsSummaryParsed" :key="key">
        <span class="label">{{ key }}: </span>
        <span>
          <span v-if="typeof opt === 'object'">
            <span v-for="(val, k) in opt" :key="k">
              <span class="value" v-if="k === 'value'">{{ val }}</span>
            </span>
          </span>
        </span>
      </div>
    </div>
    <div v-else-if="productOptsSummaryParsed.Dimensione" class="short">
      <div>Dimensione:</div>
      <div>{{ productOptsSummaryParsed.Dimensione.value }}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "EbsnSelectedOpts",
  props: {
    full: { type: Boolean, default: false },
    productOptsSummary: { type: String, required: true }
  },
  computed: {
    productOptsSummaryParsed() {
      if (this.productOptsSummary) {
        try {
          return JSON.parse(this.productOptsSummary);
        } catch (e) {
          return null;
        }
      }
      return null;
    }
  }
};
</script>
<style lang="scss" scoped>
.full {
  .value {
    font-weight: 600;
  }
}
.short {
  margin-left: 8px;
}
</style>
